import { render, staticRenderFns } from "./AppSkeleton.vue?vue&type=template&id=78e5f398&scoped=true"
import script from "./AppSkeleton.vue?vue&type=script&lang=js"
export * from "./AppSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e5f398",
  null
  
)

export default component.exports